var map = {
	"./planet_earth_black.png": 9540,
	"./planet_jupiter_black.png": 6939,
	"./planet_mars_black.png": 8769,
	"./planet_mercury_black.png": 9847,
	"./planet_moon_black.png": 237,
	"./planet_neptune_black.png": 7319,
	"./planet_pluto_black.png": 2938,
	"./planet_saturn_black.png": 1827,
	"./planet_sun_black.png": 26,
	"./planet_uranus_black.png": 9798,
	"./planet_venus_black.png": 8271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2399;